// extracted by mini-css-extract-plugin
export default {"candidateScroll":"candidate-selection-modal_candidateScroll__ucXWt"};